export interface IGame {
  gameId: string;
  url: string;
  name: string;
  orientation: 'HORIZONTAL' | 'VERTICAL';
  logo?: string;
  cover?: string;
  splashImage?: string;
  lastOpenTime?: number;
  description?: string;
  externalHost?: boolean;
}

export interface IRecommendationData {
  buttons: IRecommendationButton[];
  /**
   * 对应 from = DRAMA_DETAIL
   */
  dramaListInfo?: null | DramaListInfo;
  /**
   * 对应 from = GAME_DETAIL
   */
  gameListInfo?: null | GameListInfo;
  /**
   * multi-lang handle by backend
   */
  title: string;
  type: IRecommendationDataType;
}

export interface IRecommendationButton {
  text: string;
  type: ERecommendationButtonType;
}

export enum ERecommendationButtonType {
  Dismiss = 'DISMISS',
  Quit = 'QUIT'
}

export interface DramaListInfo {
  dramas: DramaDTO[];
}

/**
 * DramaDTO
 */
export interface DramaDTO {
  /**
   * homepage banner
   */
  cover: string;
  dramaId: string;
  name: string;
  /**
   * times of play
   */
  views: number;
  [property: string]: any;
}

export interface GameListInfo {
  games: IGame[];
}

export enum IRecommendationDataType {
  RamdomDrama = 'RANDOM_DRAMA',
  RandomGame = 'RANDOM_GAME'
}
